var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beacon-loading"},[_c('div',{staticClass:"v-center"},[_vm._v(" L "),_c('loading-circle',{staticClass:"mr-2 ml-4"}),_vm._v(" ADING "),_c('div',{staticClass:"dot mt-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }